import StatusStamp from './StatusStamp'

export * from './StatusStamp'
export default StatusStamp
